import type { SalesPromotionDto } from '@/services/ws-funnel/src/main/resources/rest-api';
import { fromDateTime } from '@/services/ws-funnel/src/main/resources/rest-api';
import dayjs from '@/js/libs/dayjs';

// For promotion, returns whether the promotion deadline is before now date
export const useIsPromotionExpired = (promotion?: SalesPromotionDto): boolean => {
  if (!promotion) return false;
  return dayjs().isAfter(fromDateTime(promotion.deadline));
};
